import {
  SubsidiariesHeaderSection,
  SubsidiaryDrawer,
  SubsidiarySection,
} from "./components";

/**
 * Subsidiaries content component
 * Displays information about company subsidiaries and divisions
 */
export function SubsidiariesContent() {
  return (
    <>
      <SubsidiariesHeaderSection />
      <SubsidiaryDrawer />
      <SubsidiarySection />
    </>
  );
}
